import React, {useRef} from 'react';
import SignatureCanvas from 'react-signature-canvas';
import DialogBox, { DialogBoxActions } from '@/_component/Common/dialog/DialogBox';
import Button from "@/_component/Common/button/Button";



const SignCanvas = ({displaySignCanvasPopUp = false, toggleSignCanvas, saveSignature}) => {
    const sigCanvas = useRef(null);

    const handleSaveSignature = () => {
        if (sigCanvas.current.isEmpty()) {
            alert('Please provide a signature');
        } else {
            const canvas = sigCanvas.current.getCanvas();

            const offscreenCanvas = document.createElement('canvas');
            const offscreenContext = offscreenCanvas.getContext('2d');

            offscreenCanvas.width = 190;
            offscreenCanvas.height = 40;

            // Calculate the aspect ratio of the original signature
            const originalWidth = canvas.width;
            const originalHeight = canvas.height;
            const aspectRatio = originalWidth / originalHeight;

            // Calculate new width and height for the resized signature, preserving the aspect ratio
            let newWidth = 190;
            let newHeight = newWidth / aspectRatio;

            // If the new height exceeds the target height, adjust based on height instead of width
            if (newHeight > 40) {
                newHeight = 40;
                newWidth = newHeight * aspectRatio;
            }

            // Draw the original canvas content onto the offscreen canvas, scaling it to the new size
            offscreenContext.drawImage(
            canvas,
            0, 0, originalWidth, originalHeight, // Source rectangle (the original canvas size)
            0, 0, newWidth, newHeight // Destination rectangle (the new canvas size)
            );

            // Get the data URL of the resized image (PNG format)
            const signatureDataUrl = offscreenCanvas.toDataURL('image/png');
            
            saveSignature(signatureDataUrl);  // Send the signature to parent component
            toggleSignCanvas();
        }
    }

    const toggleHandleClose = () => {
        toggleSignCanvas();
    }

    const handleClearSignature = () => {
        sigCanvas.current.clear()
    }

    return(
        <div>
            {
                displaySignCanvasPopUp && <DialogBox onClose={toggleHandleClose} title="Signature Pad">
                    <SignatureCanvas ref={sigCanvas} backgroundColor="white" penColor="black" canvasProps={{ width: '500', height: 200 }}/>
                    <div className='d-flex justify-content-center'>
                        <Button secondary rounded outline small
                            onClick={() => handleSaveSignature()}
                        >
                            Save Signature
                        </Button>
                        <Button secondary rounded outline small
                            onClick={() => handleClearSignature()}
                        >
                            Clear Signature
                        </Button>
                    </div>
                </DialogBox>
            }
        </div>
        
    )
}

export default SignCanvas